import { pushEvent } from "../track";

export const VIDEO = {
    view: "video_view",
    start: "video_start",
    progress: (pct) => `video_progress_${pct}%`,
    error: "video_error",
    finish: "video_finish",
    complete: "video_complete",
    loaded: "video_loaded"
};

export function pushVideoEvent(options) {
    pushEvent({
        ...options,
    });
}
